












































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import EvoTalksFilaAtendenteModel from '@/models/crm/evotalks-fila-atendente.model';
import EvoTalksTemplateModel from '@/models/crm/evotalks-template.model';
import EvoTalksOpenChatModel from '@/models/crm/evotalks-open-chat.model';
import CRMEvoTalksService from '@/services/crm/evotalks.service';
import {
  EvoTalksTemplatePreviewPart,
  EvoTalksTemplateValues,
  IEvoTalksTemplateSend,
  initialTemplateValues,
  isTemplateComplete,
  orderedTemplateValues,
  templatePreviewParts,
} from '@/utils/helpers/evotalks-template-helper';

@Component({})
export default class EvoTalksQueueSelectDialog extends Vue {
  @inject(InjectionIdEnum.CRMEvoTalksService)
  private evotalksService!: CRMEvoTalksService;

  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: () => [] })
  queues!: EvoTalksFilaAtendenteModel[];

  @Prop()
  number!: string;

  @Prop({ default: false })
  sending!: boolean;

  queue: EvoTalksFilaAtendenteModel | null = null;

  openChats: EvoTalksOpenChatModel[] = [];

  loadingOpenChats = false;

  templates: EvoTalksTemplateModel[] = [];

  loadingTemplates = false;

  templatesError: string | null = null;

  template: EvoTalksTemplateModel | null = null;

  values: EvoTalksTemplateValues = {};

  search: string | null = '';

  @Watch('value', { immediate: true })
  onOpen(open: boolean): void {
    if (!open) {
      return;
    }
    this.template = null;
    this.queue = null;
    this.openChats = [];
    this.loadOpenChats();
    if (this.queues.length === 1) {
      this.selectQueue(this.queues[0]);
    }
  }

  get queueOpenChat(): EvoTalksOpenChatModel | undefined {
    return this.queue ? this.openChatOf(this.queue) : undefined;
  }

  get filteredTemplates(): EvoTalksTemplateModel[] {
    const term = (this.search ?? '').trim().toLowerCase();
    if (!term) {
      return this.templates;
    }
    return this.templates.filter((item) => [item.name, item.category, item.text]
      .some((field) => (field ?? '').toLowerCase().includes(term)));
  }

  get previewParts(): EvoTalksTemplatePreviewPart[] {
    return this.template ? templatePreviewParts(this.template.text ?? '', this.values) : [];
  }

  get canSend(): boolean {
    return !!this.template && this.template.supported && isTemplateComplete(this.template.variables, this.values);
  }

  openChatOf(queue: EvoTalksFilaAtendenteModel): EvoTalksOpenChatModel | undefined {
    return this.openChats.find((chat) => chat.evoQueueId === queue.evoQueueId);
  }

  filled(position: number): boolean {
    return (this.values[position] ?? '').trim() !== '';
  }

  // eslint-disable-next-line class-methods-use-this
  marker(position: number): string {
    return `{{${position}}}`;
  }

  variableLabel(position: number): string {
    return `${this.$t('crm.chatCallerButton.queueDialog.variable', { marker: this.marker(position) })}`;
  }

  selectQueue(queue: EvoTalksFilaAtendenteModel | null): void {
    this.queue = queue;
    this.template = null;
    this.templates = [];
    this.search = '';
    if (queue) {
      this.loadTemplates(queue);
    }
  }

  selectTemplate(template: EvoTalksTemplateModel): void {
    this.template = template;
    this.values = initialTemplateValues(template.variables);
  }

  send(): void {
    if (!this.queue || !this.template || !this.canSend) {
      return;
    }
    const payload: IEvoTalksTemplateSend = {
      queue: this.queue,
      templateId: this.template.id,
      values: orderedTemplateValues(this.template.variables, this.values),
    };
    this.$emit('send', payload);
  }

  // Falha aqui so tira o aviso de "em atendimento" da lista: o envio repete a checagem no v24.
  private async loadOpenChats(): Promise<void> {
    if (!this.number) {
      return;
    }
    this.loadingOpenChats = true;
    try {
      this.openChats = await this.evotalksService.getOpenChats(this.number);
    } catch (err) {
      this.openChats = [];
    } finally {
      this.loadingOpenChats = false;
    }
  }

  private async loadTemplates(queue: EvoTalksFilaAtendenteModel): Promise<void> {
    this.loadingTemplates = true;
    this.templatesError = null;
    try {
      const templates = await this.evotalksService.getQueueTemplates(queue.evoQueueId);
      if (this.queue === queue) {
        this.templates = templates;
      }
    } catch (err) {
      this.templatesError = (err as Error)?.message
        || `${this.$t('crm.chatCallerButton.queueDialog.loadTemplatesError')}`;
    } finally {
      this.loadingTemplates = false;
    }
  }
}
